export default {
  services_url: 'http://wap.mabangwj.com/' + 'api',
  merchant_url: 'http://wap.mabangwj.com/' + 'admin',
  websocket_url: 'http://wap.mabangwj.com/' + 'api'
}
